"use client"

import { create } from "zustand"
import Cookies from "js-cookie"
import { devtools } from "zustand/middleware"

interface UserStore {
  userId: string | null
  profileId: string | null
  reseller: boolean,
  setProfile: (id: string) => void
  setUser: (id: string) => void,
  setReseller: (reseller: boolean) => void,
  unsetProfile: () => void
  logout: () => void
}

const COOKIE_OPTIONS = { path: "/", expires: 180, secure: true }

export const useUserStore = create<UserStore>()(
	devtools((set) => ({
		userId: null,
		profileId: null,
		reseller: false,

		setUser: (id: string) => {
			Cookies.set("userId", id, COOKIE_OPTIONS) // persistencia
			set({ userId: id })
		},

		setProfile: (id: string) => {
			Cookies.set("profileId", id, COOKIE_OPTIONS) // persistencia
			set({ profileId: id })
		},

		unsetProfile: () => {
			Cookies.remove("profileId", COOKIE_OPTIONS)
			set({ profileId: null })
		},

		logout: () => {
			Cookies.remove("userId", COOKIE_OPTIONS)
			Cookies.remove("profileId", COOKIE_OPTIONS)
			Cookies.remove("reseller", COOKIE_OPTIONS)
			set({ userId: null, profileId: null })
		},
		setReseller: (reseller:boolean) => {
			Cookies.set("reseller", reseller.toString(), COOKIE_OPTIONS) // persistencia
			set({ reseller: reseller })
		},
		unsetReseller: () => {
			Cookies.remove("reseller", COOKIE_OPTIONS) // persistencia
			set({ reseller: false })
		}
	}), {
		name: 'user-store',
    enabled: process.env.NODE_ENV === 'development'
	})
)
